import React from 'react';

const Loadable = React.lazy(() => import('../../pages/HomeV2/HomeV2'));

export default Loadable;
